import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import cn from "classnames";
import styles from "./Header.module.sass";
import DropdownMenu from "./DropdownMenu";
import Icon from "../Icon";
import Image from "../Image";

const navLinks = [
    {
        title: "Contrats",
        content: {
            info: "Gérez et automatisez toutes vos démarches administratives",
            menu: [
                {
                    title: "Tutoriels",
                    url: "/contact",
                    image: "/images/menu-video.svg",
                },
            ],
            links: [
                {
                    title: "Contrat Apprentissage",
                    url: "/contrat-apprentissage",
                    image: "/images/content/header-pic-1.png",
                    image2x: "/images/content/header-pic-1.png",
                    category: "blue",
                    categoryText: "Contrat",
                    description: "Gérez vos contrats d'apprentissage de A à Z",
                    content:
                        "Automatisez la création, le suivi et la validation de vos contrats d'apprentissage ou de professionnalisation.",
                },
                {
                    title: "Contrat P2S",
                    url: "/contact",
                    image: "/images/content/header-pic-2.png",
                    image2x: "/images/content/header-pic-2.png",
                    category: "red",
                    categoryText: "Bientôt disponible",
                    description: "Simplifiez la gestion des contrats P2S",
                },
                {
                    title: "Contrat Pro A",
                    url: "/contact",
                    image: "/images/content/header-pic-3.png",
                    image2x: "/images/content/header-pic-3.png",
                    category: "red",
                    categoryText: "Bientôt disponible",
                    description: "Optimisez vos contrats de professionnalisation",
                },
                {
                    title: "Connexion OPCO",
                    url: "/opco",
                    image: "/images/content/header-pic-4.png",
                    image2x: "/images/content/header-pic-4.png",
                    category: "blue",
                    categoryText: "OPCO",
                    description: "Intégration directe avec tous les OPCO (Suivi, Facturation)",
                },
            ],
        },
    },
    {
        title: "Fonctionnalités",
        content: {
            info: "Découvrez nos fonctionnalités avancées",
            menu: [
                {
                    title: "Tutoriels",
                    url: "/contact",
                    image: "/images/menu-video.svg",
                },
                {
                    title: "Support",
                    url: "/contact",
                    image: "/images/menu-class.svg",
                },
            ],
            links: [
                {
                    title: "Émargement & Assiduité",
                    url: "/emargement-assiduite",
                    image: "/images/content/pic-emargement.png",
                    image2x: "/images/content/pic-emargement.png",
                    category: "green",
                    categoryText: "Nouveau",
                    description: "Organisez et planifiez vos cours facilement",
                    content:
                        "Emargement en présentiel ou en distanciel, la signature des feuilles de présence en ligne et le suivi de l'assiduité des apprenants en temps réel.",
                },
                {
                    title: "Prospection & leads",
                    url: "/prospection-leads",
                    image: "/images/content/header-pic-3.png",
                    image2x: "/images/content/header-pic-3@2x.png",
                    category: "blue",
                    categoryText: "Fonctionnalité",
                    description: "Gestion des leads et suivi des prospects",
                },
                {
                    title: "Rapports & Statistiques",
                    url: "/rapports-statistiques",
                    image: "/images/content/header-pic-2.png",
                    image2x: "/images/content/header-pic-2@2x.png",
                    category: "blue",
                    categoryText: "Fonctionnalité",
                    description: "Générez des rapports et des statistiques en temps réel",
                },
                {
                    title: "Espace Gestion de documents",
                    url: "/gestion-documents",
                    image: "/images/content/header-pic-2.png",
                    image2x: "/images/content/header-pic-2@2x.png",
                    category: "blue",
                    categoryText: "Fonctionnalité",
                    description: "Gestion des documents en dématérialisé",
                },
            ],
        },
    },
    {
        title: "Forfaits",
        url: "/forfaits",
    },
    {
        title: "Actualités",
        url: "/actualites",
    },
];

const Headers = () => {
    const [visibleNav, setVisibleNav] = useState(false);

    const { pathname } = useLocation();

    return (
        <header className={styles.header}>
            <div className={cn("container", styles.container)}>
                <Link
                    className={styles.logo}
                    to="/"
                    onClick={() => setVisibleNav(false)}
                >
                    <Image
                        className={styles.pic}
                        src="/images/logo-dark.svg"
                        srcDark="/images/logo-light.svg"
                        alt="Logo Edutio"
                    />
                </Link>
                <div
                    className={cn(styles.wrap, { [styles.active]: visibleNav })}
                >
                    <nav className={styles.nav}>
                        {navLinks.map((x, index) =>
                            x.content ? (
                                <DropdownMenu
                                    className={styles.group}
                                    item={x}
                                    key={index}
                                    setValue={setVisibleNav}
                                />
                            ) : (
                                <NavLink
                                    className={cn(styles.link, {
                                        [styles.active]: pathname === x.url,
                                    })}
                                    to={x.url}
                                    key={index}
                                    onClick={() => setVisibleNav(false)}
                                >
                                    {x.title}
                                </NavLink>
                            )
                        )}
                    </nav>
                    <div className={styles.details}>
                        <Link
                            className={cn(
                                "button-stroke button-small",
                                styles.button
                            )}
                            to="/contact"
                        >
                            Contact
                        </Link>
                        <a
                            className={cn(
                                "button-stroke button-small",
                                styles.button
                            )}
                            href="https://app.edutio.fr/"
                        >
                            Se connecter
                        </a>

                    </div>
                </div>
                <Link
                    className={cn("button-stroke button-small", styles.button)}
                    to="/contact"
                >
                    Contact
                </Link>
                <div style={{ width: '12px' }}></div>
                <a
                    className={cn("button button-small", styles.button)}
                    href="https://app.edutio.fr/"
                >
                    Se connecter
                </a>

                <button
                    className={cn(styles.burger, {
                        [styles.active]: visibleNav,
                    })}
                    onClick={() => setVisibleNav(!visibleNav)}
                ></button>
            </div>
        </header>
    );
};

export default Headers;
